var PriceTableModelV2 = function(pageModelHndl) {
    var that = this;
    var requestHandle;

    that.ArticleReference = ko.observable();
    that.Amount = ko.observable();
    that.AdvantageousAmount = ko.observable();
    that.AmountDifference = ko.computed(function() {
        return that.AdvantageousAmount() - that.Amount();
    });
    that.ProductionTimeTypeId = ko.observable(1);

    that.IsLoading = ko.observable(false);
    that.IsDependencyLoading = ko.computed(function() {
        return !pageModelHndl.pProductModel.IsProductModelValid();
    }, this, { pure: true });
    that.IsTableCollapsed = ko.observable(false);
    that.TableCollapsedItemCount = ko.observable(5);

    var isBeginnerMode = $("#hfInitialModeId").val() === "MODE_0";
    if (isBeginnerMode || pageModelHndl.IsPriceTableCollapsedDefault()) {
        that.IsTableCollapsed = ko.observable(true);
    } else {
        that.IsTableCollapsed = ko.observable(false);
    }

    var getArticleReference = function() {
        var getArticleReferenceForConfigUrl = $("#getArticleReferenceUrl").val();

        var productConfigurationFilterModel = new ProductConfigurationFilterModel(pageModelHndl);
        var data = ko.mapping.toJSON(productConfigurationFilterModel);
        console.log("getArticleReference sending ", JSON.parse(data));

        return $.ajax({
            url: getArticleReferenceForConfigUrl,
            type: "POST",
            data: data,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).fail(function() {
            alerts.error();
            that.IsLoading(false);
        }).done(function(result) {
            if (result.Success) {
                that.ArticleReference(result.Model.articleReference);
            } else {
                alerts.error();
            }
        });
    };

    var abortPendingRequest = function() {
        if (that.IsLoading()) {
            that.IsLoading(false);
            if (requestHandle) {
                requestHandle.abort();
                console.info("aborted call to getAmountPriceTable");
            }
        }
    };

    var getAmountPriceTable = function(articleReference, amount, isAmountEnteredByUser) {
        var getAmountPriceTableUrl = $("#getAmountPriceTableUrl").val();
        var params = {
            ArticleReference: articleReference,
            shippingCountryId: pageModelHndl.DefaultDeliveryCountryId(),
            individualAmount: amount ? amount : null,
            isAmountEnteredByUser: isAmountEnteredByUser ? isAmountEnteredByUser : false,
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct()
        };
        console.log(amount);
        console.log("getAmountPriceTable sending ", params);

        requestHandle = $.ajax({
            url: getAmountPriceTableUrl,
            type: "GET",
            data: params
        }).done(function (result) {
            $("#priceAmountTabelV2Container").html(result);
            that.Amount($("#individualAmount").val());
            pageModelHndl.CurrentAmount($("#individualAmount").val());
            that.AdvantageousAmount($("#advantageousAmountDiv").html());
            pageModelHndl.pProductModel.ArticleReference(that.ArticleReference());
            pageModelHndl.pFilePresetModel.GetFilePreset();
            if (that.IsTableCollapsed()) {
                that.ShowLessPrices();
            } else {
                that.ShowMorePrices();
            }

            that.AdjustProductConfigMode();

            if (!pageModelHndl.IsEditMode()) {
                that.UpdateSammyUrl();
            }
            }).fail(function (xhr) {
            dontShowErrorIfRequestIsCancelled(xhr);
        }).always(function() {
            that.IsLoading(false);
        }).done(function() {
            pageModelHndl.pOrderOptionsModelV2.LoadOrderOptionsData();
            pageModelHndl.pAdditionalWorkModelV2.LoadAdditionalWorkData();
        });
        return requestHandle;
    };

    function dontShowErrorIfRequestIsCancelled(xhr) {
        var isRequestAborted = xhr && xhr.statusText !== "abort";
        if (isRequestAborted) {
            alerts.error();
        }
    }

    var updatePriceTableData = function(amount, isAmountEnteredByUser) {
        abortPendingRequest();
        that.IsLoading(true);
        getArticleReference().then(function(result) {
                if (!result.Success) {
                    console.error("RequestArticleReference has failed with a server error");

                    var t = $.Deferred();
                    t.reject();
                    return t.promise();
                }

                return getAmountPriceTable(result.Model.articleReference, amount, isAmountEnteredByUser);
            },
            function() {
                that.IsLoading(false);
            }).always(function() {
            that.IsLoading(false);
        });
    };

    that.UpdatePriceTableData = function (amount, isAmountEnteredByUser) {
        if (pageModelHndl.IsCatalogueProduct()) {
            that.UpdatePricetableDataByArticleReference(that.ArticleReference(), amount, isAmountEnteredByUser);
        } else {
            updatePriceTableData(amount, isAmountEnteredByUser);
        }
    };

    that.UpdatePricetableDataByArticleReference = function(articleReference, amount, isAmountEnteredByUser) {
        abortPendingRequest();
        that.ArticleReference(articleReference);
        that.IsLoading(true);
        getAmountPriceTable(articleReference, amount, isAmountEnteredByUser).always(function() {
            that.IsLoading(false);
        });
    };

    that.UpdateSammyUrl = function() {
        var articleReference = that.ArticleReference();
        var amountPrefix = "";
        if(IsProductConfigurationV3(articleReference)) {
            amountPrefix = "MEN";
        }
         
        articleReference = articleReference.substring(0, articleReference.lastIndexOf("_") + 1) + amountPrefix + that.Amount();

        // stop *.Sammy.js
        pageModelHndl.pSammyModel.IsPaused(true);

        // set hash
        window.location.hash = "/show/" + articleReference;

        // resume *.Sammy.js
        setTimeout(function() {
            pageModelHndl.pSammyModel.IsPaused(false);
        }, 1000);
    };
    
    function IsProductConfigurationV3(articleReference) {
        return articleReference.substring(0,3) === "OID";
    }

    that.ShowLessPrices = function() {
        that.IsTableCollapsed(true);

        var $rows = $("tr.PreiseRow");
        var selectedId = "#priceTableAmount_" + that.Amount() + "_productionType_" + that.ProductionTimeTypeId();
        $rows.each(function(index, element) {
            if (index >= that.TableCollapsedItemCount() && $(element).children("td" + selectedId).length === 0) {
                $(element).hide();
            }
        });
    };

    that.ShowMorePrices = function() {
        that.IsTableCollapsed(false);

        $("tr.PreiseRow").each(function() {
            $(this).show();
        });
    };

    that.SetSelectedClass = function() {
        var selected = $("#priceTableAmount_" + that.Amount() + "_productionType_" + that.ProductionTimeTypeId());
        if (selected) {
            $("#amountPricesTableHolder").find('*').removeClass("selected");
            selected.addClass("selected");
        }
    };

    that.SetBeginnerMode = function() {
        var table = $("#amountPriceTableV2");
        table.addClass("amountPricesBeginner");
    };

    that.RemoveBeginnerMode = function() {
        var table = $("#amountPriceTableV2");
        table.removeClass("amountPricesBeginner");
    };

    that.AdjustProductConfigMode = function() {
        if (pageModelHndl.pProductContentModeModel.SelectedModeId() === "MODE_0") {
            that.SetBeginnerMode();
        } else {
            that.RemoveBeginnerMode();
        }
    };
    
    that.SelectAmount = function(element) {
        // don't reload when we already have selected the amount
        if (that.Amount() != element.data("amount")) {
            that.UpdatePriceTableData(element.data("amount"), true);
            that.Amount(element.data("amount"));
        }
        that.SetSelectedClass();
        if (element.data("productiontimetype")) {
            that.ProductionTimeTypeId(element.data("productiontimetype"));
            pageModelHndl.pOrderOptionsModelV2.UpdateProductionType(that.ProductionTimeTypeId());
        }
    };

    $(function() {
        var $context = $("#productConfigurationMainDiv");
        $context.on("change", "#mobileAmountSelect", function () {
            if ($(this).val() === "individual") {
                $('#mobileIndividualAmountBox').removeClass("hidden d-none");
            } else {
                $('#mobileIndividualAmountBox').addClass("hidden d-none");
                that.UpdatePriceTableData($(this).val(), true);
            }
        });

        $context.on("change", "#individualAmount, #mobileindividualAmount", function () {
            that.UpdatePriceTableData($(this).val(), true);
        });
        // fallback for IE
        $context.on("keypress", "#individualAmount, #mobileindividualAmount", function(e) {
            if (e.which === 13 && that.Amount() !== $(this).val()) {
                that.UpdatePriceTableData($(this).val(), true);
            }
        });

        $context.on("click", ".amount-select", function(e) {
            that.SelectAmount($(this));
        });

        $context.on("click", "#applyAmount", function(e) {
            that.SelectAmount($(this));
        });

        $context.on("click", ".productPropOptions .option-click input",
            function() {
                var amount = $(this).parent().data("amount");
                that.Amount(amount);
                pageModelHndl.pOrderOptionsModelV2.LoadOrderOptionsData();
                pageModelHndl.pAdditionalWorkModelV2.LoadAdditionalWorkData();
            });
    });
};
